var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CD2088",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.795 4.76h-1.389V0h-16.8V4.733h-1.39C.989 4.733 0 5.763 0 7.043v8.742c0 1.28.988 2.31 2.217 2.31h.56v5.847h13.756l4.675-4.872v-.947h.56c1.23 0 2.218-1.03 2.218-2.31V7.07c.026-1.28-.962-2.31-2.19-2.31zm-16.8-3.285H18.99V4.76H4.995V1.475zm-.561 20.768v-7.015h15.144v3.146l-.053.055h-3.686v3.814H4.434zm17.949-6.43c0 .334-.267.584-.561.584h-.56v-2.895H2.777v2.923h-.561c-.32 0-.561-.278-.561-.585V7.071c0-.334.267-.585.56-.585h19.58c.32 0 .56.279.56.585v8.742h.027zm-5.037-6.57c0 .39-.334.723-.724.723-.39 0-.724-.334-.724-.723 0-.39.334-.724.724-.724.39 0 .724.334.724.724zm2.923 0c0 .39-.334.723-.724.723-.39 0-.724-.334-.724-.723 0-.39.334-.724.724-.724.39 0 .724.334.724.724z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.8300ee69.svg";
export { ForwardRef as ReactComponent };